import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

const EMOJIS = [{ e: "🔥", key: "fire" }, { e: "😂", key: "laugh" }];
const BACKEND = process.env.REACT_APP_BACKEND_URL;

// The MVP's posted final-blow clip + one-tap 🔥/😂 reactions, shown in the squad recap so
// teammates can cheer it. Self-managed: fetches reaction counts, toggles on tap.
export default function ClipReactions({ clipId, uploaderName }) {
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    if (!clipId) return;
    let alive = true;
    api.get(`/clips/${clipId}/meta`).then((r) => { if (alive) setMeta(r.data); }).catch(() => { if (alive) setMeta({ reactions: {}, my_reactions: [] }); });
    return () => { alive = false; };
  }, [clipId]);

  const react = async (emoji) => {
    try {
      const { data } = await api.post(`/clips/${clipId}/react`, { emoji });
      setMeta((m) => ({ ...(m || {}), reactions: data.reactions, my_reactions: data.my_reactions }));
    } catch {
      toast.error("Log in to react to the clip.");
    }
  };

  if (!clipId) return null;
  const reactions = meta?.reactions || {};
  const mine = meta?.my_reactions || [];

  return (
    <div className="rounded-xl border border-fuchsia-500/40 bg-fuchsia-500/5 p-3 space-y-2.5" data-testid="squad-clip-block">
      <div className="text-xs font-bold text-fuchsia-300">🎬 {uploaderName || "MVP"}'s final blow — cheer it!</div>
      <video src={`${BACKEND}/api/clips/file/${clipId}`} controls autoPlay loop muted playsInline
        className="w-full rounded-lg border border-[hsl(var(--border))] bg-black" data-testid="squad-clip-video" style={{ aspectRatio: "16/9" }} />
      <div className="flex gap-2">
        {EMOJIS.map((x) => {
          const on = mine.includes(x.e);
          return (
            <button key={x.key} onClick={() => react(x.e)} data-testid={`squad-clip-react-${x.key}`}
              className={`flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-sm font-semibold transition-colors ${on ? "border-fuchsia-500/60 bg-fuchsia-500/15 text-fuchsia-300" : "border-[hsl(var(--border))] text-[hsl(var(--muted-foreground))] hover:bg-[hsl(var(--accent))]"}`}>
              <span className="text-base">{x.e}</span> {reactions[x.e] || 0}
            </button>
          );
        })}
      </div>
    </div>
  );
}
